<template>
  <div :id="`reply-${reply.id}`" class="thread-reply" data-test-id="thread-reply">
    <user-byline
      v-if="reply.user"
      :user="reply.user"
      :date="reply.insertedAt"
      :show-date="true"
      :show-preposition="false"
    />
    <div class="thread-reply__body">
      <component :is="bodyWithMentions" v-if="bodyWithMentions.template" />
      <div v-else v-html="body" />
    </div>
    <div class="thread-reply__engagement">
      <engagement-reply-bar
        object-type="reply"
        :comment="reply"
        :the-object="thread"
        @delete="deleteReply"
        @submitted="handleReplySubmitted"
      />
    </div>
    <thread-child-replies
      v-if="reply.replies"
      ref="child-replies"
      :replies="reply.replies"
      :thread="thread"
      :parent-reply-id="reply.id"
    />
  </div>
</template>

<script>
import UserByline from '@/components/User/UserByline.vue';
import InlineMention from '@/components/Mention/InlineMention.vue';
import parseMentionsMixin from '@/mixins/parse-mentions-mixin';
import scrollToMixin from '@/mixins/scroll-to-mixin';
import EngagementReplyBar from '@/components/Engagement/EngagementReplyBar.vue';
import ThreadChildReplies from '@/components/Thread/ThreadChildReplies.vue';
import { DELETE_REPLY } from '@/graphql/mutations/thread-mutation';

export default {
  name: 'ThreadReply',
  components: {
    UserByline,
    EngagementReplyBar,
    ThreadChildReplies,
    InlineMention,
  },
  mixins: [
    parseMentionsMixin,
    scrollToMixin,
  ],
  props: {
    reply: {
      type: Object,
      required: true,
    },
    thread: {
      type: Object,
      required: true,
    },
  },
  computed: {
    body() {
      if (!this.reply.body) { return null; }
      const regexp = new RegExp(/[\u2063]/, 'g');
      return this.reply.body.replace(regexp, '');
    },
  },
  methods: {
    handleReplySubmitted(replyData) {
      this.$refs['child-replies'].showPreviousReplies();
      this.$nextTick(() => {
        this.scrollTo(`#reply-${replyData.id}`);
      });
    },
    deleteReply() {
      this.$apollo.mutate({
        mutation: DELETE_REPLY,
        variables: {
          id: this.reply.id,
        },
      }).then(() => {
        this.$store.dispatch('addToastNotification', {
          toastType: 'success',
          description: 'Your reply was deleted',
          type: 'Forum',
        });
        this.$router.go();
      }).catch(() => {
        this.$store.dispatch('addGenericErrorNotification');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_thread-reply';
</style>

<style lang="scss"> // no scoped - to reach HTML content
  .thread-reply__body a:focus {
    @include highlighter-focus();
  }
</style>

<docs>
A single Reply that displays on a Thread.

</docs>
